(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        return {
            restrict: 'A',
            scope   : false,
            require : '^jhSort',
            link    : linkFunc
        };
        // eslint-disable-next-line
        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();
